export const styles = () => ({
  moreIcon: {
    marginLeft: 6
  }
})



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingsOptions/styles.js